<template>
  <div class="index-header" :style="headerStyle">
    <div
      class="user-info"
      :class="{ clickable }"
      :style="{ background: background }"
      @click="handleClick"
    >
      <div class="avatar">
        <img
          v-if="user"
          :src="user.avatar || require('@/assets/default-avatar.png')"
          alt="头像"
        />
      </div>
      <div v-if="user" class="nick-name">{{ user.nickname }}</div>
      <van-icon
        v-if="user && user.province_code && user.province_code != '0'"
        name="arrow"
        color="#fff"
        size="18"
        class="arrow-icon"
      />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    user: {
      type: Object,
      default: null,
    },
    background: {
      type: String,
      default: "rgba(90, 117, 236, 0.7)",
    },
    absolute: {
      type: Boolean,
      default: true,
    },
    clickable: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    headerStyle() {
      if (this.absolute) {
        return { position: "absolute", top: "30px" };
      }
      return { marginTop: "30px" };
    },
  },
  methods: {
    handleClick() {
      if (!this.clickable) return;
      if (
        this.user &&
        this.user.province_code &&
        this.user.province_code != "0" &&
        this.user.city_code &&
        this.user.city_code != "0"
      ) {
        this.$router.push("/userInfo");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.index-header {
  z-index: 1;
  .user-info {
    display: flex;
    align-items: center;
    max-width: 120px;
    padding: 5px 22px;
    border-radius: 0 24px 24px 0;

    &.clickable {
      cursor: pointer;
    }

    .avatar {
      flex-shrink: 0;
      width: 39px;
      height: 39px;
      margin-right: 10px;
      overflow: hidden;
      vertical-align: top;
      border-radius: 50%;

      img {
        width: 100%;
        vertical-align: top;
      }
    }

    .nick-name {
      max-width: 100px;
      max-height: 35px;
      font-size: 14px;
      line-height: 35px;
      color: #fff;
      @include textoverflow(1);
    }
  }
}
</style>
